export const classes = {
  cell: 'select-none text-xs text-grey-5 font-semibold tracking-wide uppercase py-3 bg-white border-b border-grey-3',
};
